import { EnumTipoDomandaModuloDTOTipoAssociazione } from '@framework/api-client';
import { t } from '@framework/i18n';

interface CommonModule {
  domandaModulo?: {
    tipoAssociazione?: EnumTipoDomandaModuloDTOTipoAssociazione | null;
  } | null;
  titoloModuloDinamico?: string | null;
}
interface Module extends CommonModule {
  titolo: string;
  modulo?: never;
}

interface SubmissionModule extends CommonModule {
  titolo?: never;
  modulo?: {
    modulo?: {
      titolo?: string | null;
    } | null;
  } | null;
}

/***
 * @param module I type di module sono stati ridotti a solo i campi necessari
 * per rendere meno succettible il codice a rotture in caso di modifiche
 */
export function getModuleTitle(module: SubmissionModule | Module): string {
  let moduleTitle = isSubmissionModule(module)
    ? module.modulo?.modulo?.titolo
    : module.titolo;

  if (
    module.domandaModulo?.tipoAssociazione ===
      EnumTipoDomandaModuloDTOTipoAssociazione.DINAMICO &&
    module.titoloModuloDinamico
  ) {
    moduleTitle = module.titoloModuloDinamico;
  }
  return moduleTitle ?? t('module-title.altro-modulo', 'Altro Modulo');
}

function isSubmissionModule(
  module: SubmissionModule | Module,
): module is SubmissionModule {
  return 'modulo' in module;
}
